/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_React_LoopsInputs */

const en_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ReAct loops`)
};

const ar_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حلقات ReAct`)
};

const bn_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ReAct লুপ`)
};

const de_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ReAct-Schleifen`)
};

const es_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bucles ReAct`)
};

const fr_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boucles ReAct`)
};

const pt_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loops ReAct`)
};

const zh_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ReAct 循环`)
};

const tr_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ReAct döngüleri`)
};

const ru_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Циклы ReAct`)
};

const pl_svchip_react_loops = /** @type {(inputs: Svchip_React_LoopsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pętle ReAct`)
};

/**
* | output |
* | --- |
* | "ReAct loops" |
*
* @param {Svchip_React_LoopsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_react_loops = /** @type {((inputs?: Svchip_React_LoopsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_React_LoopsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_react_loops(inputs)
	if (locale === "bn") return bn_svchip_react_loops(inputs)
	if (locale === "de") return de_svchip_react_loops(inputs)
	if (locale === "es") return es_svchip_react_loops(inputs)
	if (locale === "fr") return fr_svchip_react_loops(inputs)
	if (locale === "pt") return pt_svchip_react_loops(inputs)
	if (locale === "zh") return zh_svchip_react_loops(inputs)
	if (locale === "tr") return tr_svchip_react_loops(inputs)
	if (locale === "ru") return ru_svchip_react_loops(inputs)
	if (locale === "pl") return pl_svchip_react_loops(inputs)
	return en_svchip_react_loops(inputs)
});